export enum TvSeriesQueryKey {
    TvSeriesDetails = "tv-series-details"
}
